export default __webpack_public_path__ + "static/media/location-off.7ef44694.svg";